import PropTypes from 'prop-types';

import { Box } from '@src/components';

export default function TwoColumn({primary, secondary}) {
  return (
    <>
      <Box>{primary}</Box>
      {secondary && <Box>{secondary}</Box>}
    </>
  );

}

TwoColumn.propTypes = {
  primary: PropTypes.node,
  secondary: PropTypes.node,

};
